import * as Grid from '@vpp-frontend-components/grid';

export default Grid;
